import { route } from '../constants/routePath';
import AxiosRequest from '../configs/api';

const CartService = {};

CartService.myCartItems = () => AxiosRequest.get(
    `/${route.cart}/api/v1/carts/v2?`
  );

CartService.updateCart = (payload) => AxiosRequest.post(
    `/${route.cart}/api/v1/carts/update/v2`,
    payload
  );
CartService.deleteItem = (payload) => AxiosRequest.post(
    `/${route.cart}/api/v1/carts/delete/v2`,
    payload
  );
CartService.addToCart = (payload) => AxiosRequest.post(
    `/${route.cart}/api/v1/carts/v2`,
    payload
  );

CartService.checkoutOrder = (payload) => AxiosRequest.post(
    `/${route.pointRedemption}/api/v2/orders`,
    payload
  );
  CartService.addToWishlist = (payload, token) => AxiosRequest.post(
    `/${route.cart}/api/v1/wishlists`,
    payload,
    token,
  );

  // CartService.cartItemCount = () => AxiosRequest.get(
  //   `/${route.cart}/api/v1/carts/count`
  // );

  CartService.cartItemCount = () =>
  AxiosRequest.get(`/${route.cart}/api/v1/carts/count/v2?`);

export default CartService;